import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";
import useStyles from "../../styles";
import CobeeTextField from "../../../../../CobeeTextField";

export default function RowInitialPrice({
  initialAmount,
  setInitialAmount,
}: {
  initialAmount: string | number;
  setInitialAmount(e: any): void;
}): JSX.Element {
  const { secondColumn, inputLabel } = useStyles();
  return (
    <>
      <Grid item xs={6}>
        <Typography variant="body2">
          {`${t("common-messages.initial-price")} ${t(
            "common-messages.optional"
          )}:`}
        </Typography>
        <Typography variant="body2">
          {t("request-section.initial-price-message")}
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        container
        alignItems="flex-start"
        className={secondColumn}
      >
        <Grid item xs={12} container alignItems="center">
          <Grid item xs={4}>
            <CobeeTextField
              styleType="default"
              variant="outlined"
              type="number"
              minWidth="100%"
              min={0}
              max={99999}
              step="1"
              value={initialAmount}
              onChange={(e) => setInitialAmount(e.target.value)}
            />
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body2" className={inputLabel}>
              EUR ({t("common-messages.tax-not-included")})
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
